<template>
    <div
      v-if="showConsent"
      class="fixed bottom-4 left-1/2 transform -translate-x-1/2 w-[90%] max-w-2xl z-50 rounded-xl 
             border border-gray-200 dark:border-gray-700 shadow-lg p-6
             bg-white text-gray-800 dark:bg-gray-900 dark:text-white flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
    >
      <div class="flex-1 text-[14px]">
        <h2 class="text-base font-semibold mb-1 uppercase tracking-wide">{{ $t('cookieconsent.1') }}</h2>
        <p class="text-gray-500 dark:text-gray-300 mb-4 leading-relaxed">{{ $t('cookieconsent.2') }}</p>
      </div>
      <div class="flex flex-col sm:flex-row-reverse gap-2 w-full sm:w-auto">
        <button
          @click="acceptCookies"
          class="h-9 px-5 text-[12px] tracking-wider uppercase inline-flex items-center justify-center font-medium
                 rounded-md bg-teal-500 text-white hover:bg-teal-600 transition w-full sm:w-auto"
        >
        {{ $t('cookieconsent.3') }}
        </button>
        <button
          @click="denyCookies"
          class="h-9 px-5 text-[12px] tracking-wider uppercase inline-flex items-center justify-center font-medium
                 rounded-md bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-700 transition w-full sm:w-auto"
        >
        {{ $t('cookieconsent.4') }}
        </button>
      </div>
    </div>
  </template>
  
  
  <script setup>
  import { ref, onMounted } from 'vue'
  
  const COOKIE_NAME = 'cookieConsent'
  const ONE_YEAR = 365 * 24 * 60 * 60 * 1000
  
  const showConsent = ref(false)
  
  onMounted(() => {
    const consent = getCookie(COOKIE_NAME)
    if (!consent) {
      showConsent.value = true
    }
  })
  
  function acceptCookies() {
    setCookie(COOKIE_NAME, 'accepted', ONE_YEAR)
    showConsent.value = false
  }
  
  function denyCookies() {
    // nie zapisujemy nic, pokaże się znowu przy odświeżeniu
    showConsent.value = false
  }
  
  function setCookie(name, value, msDuration) {
    const date = new Date()
    date.setTime(date.getTime() + msDuration)
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`
  }
  
  function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }
  </script>
  